skrilla.service('validationService', function($state) {

    function validateForm(inputs, validate){
        var valid = true;
        inputs.forEach(function(input){
            var result = isFieldValid(input.condition, input.message)
            validate[input.field] = result;
            valid = valid === true && result === "";
        })
        return valid;
    }

    function buildFieldValidationObj(fieldName, condition, message){ return {field: fieldName, condition: condition, message: message};}

    function isFieldValid(condition, message){
        return condition ? "" : message;
    }

    function isEmpty(input){
        return input === null || input === undefined || input === "" || input.length === 0;
    }

    function isNotEmpty(input){
        return !isEmpty(input);
    }

    function isEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    function isEthereumAddress(address){
        //simple check
        return (/^(0x)?[0-9a-f]{40}$/i.test(address));
    }

    function isDate(input) {
        return input instanceof Date;
    }

    function isNumberGreaterThanZero(input){
        return !Number.isNaN(Number.parseFloat(input)) && input > 0
    }

    return {
        validateForm:validateForm,
        buildFieldValidationObj: buildFieldValidationObj,
        isEmpty: isEmpty,
        isNotEmpty: isNotEmpty,
        isEmail: isEmail,
        isEthereumAddress:isEthereumAddress,
        isDate: isDate,
        isNumberGreaterThanZero: isNumberGreaterThanZero
    };
});
